/*requires ../leaflet/leaflet.js */


//
// Project actions javascript
//
//  Josh Norris
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.registerNamespace("HEIJS.page");

//
//  Projects 
//
HEIJS.Projects = function ()
{
  this.init();
  this.service = new RESTService({ baseUrl: HEIJS.context.convertToContextUri('https://inet.hendersonengineers.com'), routePrefix: 'Projects/API' });
};

HEIJS.Projects.prototype =
{
  service: null,
  favorites:
  {
    parent: null,
    afterProjectAdded: null,
    afterProjectRemoved: null,

    init: function () {
      this.afterProjectAdded = new HEIJS.Event();
      this.afterProjectRemoved = new HEIJS.Event();
    },

    addFavoriteProject: function (projectId, callback)
    {
      this.parent.service.Update('FavoriteProject', { projectId: projectId, favorite: true }).then(callback);
    },

    removeFavoriteProject: function (projectId, callback)
    {
      this.parent.service.Update('FavoriteProject', { projectId: projectId, favorite: false }).then(callback);
    },

    getAssignedEmployeesForProject: function (projectId, callback)
    {
      this.parent.service.Get('AssignedEmployeeEmails', { projectId: projectId }).then(callback);
    }
  },

  data:
  {
    parent: null,
    _downloadnumber: 0,
    _callbacks: [],
    afterProjectStatusUpdated: null,

    init: function ()
    {
      this.afterProjectStatusUpdated = new HEIJS.Event();
    },

    getProjectById: function (projectId, callback)
    {
      var self = this;
      var fields = 0; //fields should be 31... basically we're getting everything
      for (var x = 0; x < this.parent.ProjectFields.length; x++)
      {
        fields += Math.pow(2, x); //2^0 + 2^1 + 2^2 + 2^3 + 2^4, etc
      }

      var gqlUrl = HEIJS.context.convertToContextUri('https://inet-svc.hendersonengineers.com/graphql');

      var projectFields = 'projectId wBS1 projectNumber phase phaseGroup phaseType projectDescription phaseDescription storeNumber status sector practice practiceFk program department isConfidential hendersonCompanyName indirect totalSize principalId principalName projectManager1Id projectManager1Name projectManager2Id projectManager2Name projectManager3Id projectManager3Name location { address1 address2 city state countryCode }'

      var params = { query: 'query($projectId: Int) { projectById(projectId: $projectId) { ' + projectFields + ' } }', variables: { projectId: projectId } }

      var requestOptions = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + HEIJS.getAccessToken()
        },
        body: JSON.stringify(params),
        credentials: 'include'
      };

      fetch(HEIJS.context.convertToContextUri(gqlUrl), requestOptions).then(function (r) { return r.json(); }).then(function (p) { callback(HEIJS.convertProjectFromGraphqlToUpperCamel(p.data.projectById)) });

    },

    getProjectActionsByWBS1: function (wbs1, callback)
    {
      this.parent.service.Get('ProjectActions', { wbs1: wbs1 }).then(callback);
    },

    getPhaseWorkBreakdown: function (projectId, callback)
    {
      this.parent.service.Get('ProjectWorkBreakdown', { projectId: projectId }).then(callback);
    },

    getProjectWorkBreakdown: function (projectNumber, callback)
    {
      this.parent.service.Get('ProjectWorkBreakdownByProjectNumber', { projectNumber: projectNumber }).then(callback);
    },

    updateProjectStatus: function (projectID, projectNumber, status, closeAllActivePhases, callback)
    {
      var self = this;
      this.parent.service.Update('ProjectStatus', { projectID: projectID, projectNumber: projectNumber.slice(0, 10), newStatus: status, closeAllActivePhases: closeAllActivePhases }).then(function(result) {
        self.finishUpdateProjectStatus(result);
        callback(result);
      });
    },

    updateProposalStatus: function (projectID, projectNumber, status, HEILanded, closeAllActivePhases, callback)
    {
      var self = this;
      this.parent.service.Update('ProposalStatus', { projectID: projectID, projectNumber: projectNumber.slice(0, 10), newStatus: status, HEILanded: HEILanded, closeAllActivePhases: closeAllActivePhases })
      .then(callback);
    },

    finishUpdateProjectStatus: function (projectData)
    {
      this.afterProjectStatusUpdated.Trigger(projectData);
    }
  },

  init: function ()
  {
    this.favorites.init();
    this.data.init();
    this.data.parent = this;
    this.favorites.parent = this;
  },

  ProjectFields: ["Standard", "Location", "Client", "Staff", "Extended", "PersonData"]
};

//
//  Project Actions
//
HEIJS.Controls.ProjectActions = function (dontSetup) {
  var self = this;
  this.afterSetupDone = new HEIJS.Event();
  this.service = new RESTService({ baseUrl: HEIJS.context.convertToContextUri('https://inet.hendersonengineers.com'), routePrefix: 'Projects/API' });

  if (dontSetup) {
    return;
  }
  
  setTimeout(function () {
    self.init();
    self.projects = $("span.wbs1").filter(function () { return self.validWBS1(this); });

    self.setupProjectSpans(self.projects);
    self.setupEvents(self.projects.filter(function(index, item) { return $(item).parents('.hei-projecttip-details-header:first').length > 0 }));
    self.buildDialog();
    self.buildHEILandedDialog();

    HEIJS.page.ProjectActionsManager = self;
    self.afterSetupDone.Trigger({});
  }, 0);
};

HEIJS.Controls.ProjectActions.prototype =
{
  //
  // Properties
  //
  service: null,
  projects: null,
  loadingMenu: null,
  currentItem: null,
  loadingItem: null,
  dialog: null,
  heiLandedDialog: null,
  map: null,
  validWBS1Patt: /\b(\d{10}\.\d{3})\b/g,
  statusCodeToDescription: {
    'A': 'Active',
    'F': 'Future',
    'H': 'On Hold',
    'C': 'Completed (No New Time)',
    'T': 'Terminated/Job Cancelled'
  },
  statusCodeToColor: {
    'A': '#5DD255',
    'F': '#FFD200',
    'H': '#FF7800',
    'C': '#4E88CE',
    'T': '#D00E0D'
  },
  staffPrefix: [ 'Principal', 'ProjectManager1', 'ProjectManager2', 'ProjectManager3' ],
  roleLookup: {
    Principal: 'Principal', 
    ProjectManager1: 'Project Manager 1', 
    ProjectManager2: 'Project Manager 2', 
    ProjectManager3: 'Project Manager 3'
  },
  disciplineCodeToColor: {
    A: '#994499', //Administration
    K: '#DD4477', //Marketing
    E: '#2980B9', //Electrical
    F: '#AD110B', //Fire
    M: '#D35400', //Mechanical
    P: '#27AE60', //Plumbing
    T: '#F2AB4F', //Technology
    R: '#4DCAEF', //Refrigeration
    X: '#84A1FF', //Commissioning
    O: '#22AA99', //Construction
    C: '#A1B2C3', //BIM Lead
    MISC: '#566C11' //Default
  },
  disciplineCodeToDescription: {
    A: 'Administration', 
    K: 'Marketing', 
    E: 'Electrical', 
    F: 'Fire', 
    M: 'Mechanical', 
    P: 'Plumbing', 
    T: 'Technology', 
    R: 'Refrigeration', 
    X: 'Commissioning', 
    O: 'Construction',
    C: 'BIM Lead',
    MISC: 'Miscellaneous' //Default
  },
  mapBoxAPIKey: 'pk.eyJ1IjoidXVjdWUyIiwiYSI6ImptcnJsVXMifQ.GQg3eqqR1RoqVobDceNveQ', //gitleaks:allow
  service: null,
  
  // events
  afterSetupDone: null,

  //
  // Methods
  //

  processNewHtml: function (parentElement) {
    this.processNonSpannedWBS1s(parentElement);
    var projectSpans = parentElement.find("span.wbs1");

    this.setupProjectSpans(projectSpans);
    this.setupEvents(projectSpans.filter(function(index, item) { return $(item).parents('.hei-projecttip-details-header:first').length > 0 }));
  },

  setupProjectSpans: function (projectSpans) {
	projectSpans.each(function(index, item) {
		if (HEIJS.page.ProjectActions.validWBS1(this)) {
			if ($(item).parents('.hei-projecttip-details-header:first').length === 0) {
				$(item).projectInfoTip({ WBS1: $(item).attr('wbs1') });
			}
		}
		else if ($(item).attr('projectId')) {
			$(item).projectInfoTip({ ProjectID: $(item).attr('projectId') });
		}
	});
  },

  // jQuery filter() function, "this" is element to be filtered
  filterOutLabeledWBS1s: function () {
    if (this.length >= 14
        && !/^\s+$/.test(this.data)
        && !$(this.parentNode).hasClass("wbs1")) {
      return HEIJS.page.ProjectActions.validWBS1Patt.test(this.data);
    }

    return false;
  },

  // jQuery replaceWith() function, "this" is element to be replaced
  replaceNonLabeledWBS1s: function (element) {
    try {
      var text = element.text();
      var elFixed = text.replace(this.validWBS1Patt, "<span class='wbs1'>$1</span>");
      return elFixed;
    }
    catch (err) {
      return null;
    }
  },

  processNonSpannedWBS1s: function (baseElement) {
    baseElement = baseElement || $("body");
    var self = this;
    baseElement.textNodes()
      .filter(this.filterOutLabeledWBS1s)
      .replaceWith(function () { return self.replaceNonLabeledWBS1s($(this)); });
  },

  init: function () {
    var self = this;

    HEIJS.page.Projects.data.afterProjectStatusUpdated.AddHandler(new HEIJS.EventHandler(
      function (projectData) {
        if (self.currentItem)
          self.hideMenu(self.currentItem);

        var wbs1ID = self.getWBS1ID(projectData.WBS1);
        $("#" + wbs1ID).remove(); //force reload of the menu
      },
      self
    ));
  },

  getWBS1ID: function (wbs1) {
    return wbs1.replace(".", "_");
  },

  parseWBS1: function (e) {
    var str = $(e).text();
    var matches = str.match(this.validWBS1Patt);

    if (matches != null) {
      if (matches.length > 0) {
        return "" + matches[0].toString();
      }
    }
    return "";
  },

  validWBS1: function (ele) {
    if (!$(ele).attr("wbs1")) {
      var val = this.parseWBS1(ele);
      $(ele).attr("wbs1", val);
    }

    if ($(ele).attr("wbs1") == "") {
      return false;
    }
	
	if ($(ele).parents(".no-wbs1-menu").length > 0) {
	  $(ele).removeClass("wbs1");
	  return false;
	}

    return true;
  },

  disableEvents: function (projectSpans) {
    projectSpans.unbind("mouseover.projectAction").unbind("mouseout.projectAction").unbind("contextmenu.projectAction");
  },

  removeActions: function (projectSpans) {
    //projectSpans.removeAttr("wbs1");
    //this.disableEvents(projectSpans);
  },

  setupEvents: function (projectSpans) {
	//todo: add hasProjectTooltip class or something whenever the tooltip is initialized and then if it doesn't have that class, initialize it
    var self = this;
    this.disableEvents(projectSpans);
    projectSpans
      .bind("mouseover.projectAction",
        function (e) {
          self.buildLoadingMenu($(this));
          $(this).addClass("wbs1-hover");  /* added the wbs1-hover, because :hover pseudo class doesn't work in quirks mode */
        })
      .bind("mouseout.projectAction",
        function (e) {
          if (!$(this).hasClass("wbs1-selected")) {
            self.closeUp($(this));
          }
        })
	    .bind("contextmenu.projectAction",
        function (e) {
          e.preventDefault();
        });
  },

  setupWBS1DropDownEvents: function (spans) {
    var self = this;
    self.disableEvents(spans);
    spans
      .bind("mouseover.projectAction",
        function (e)
        {
          self.buildLoadingMenu($(this));
        })
      .bind("mouseout.projectAction",
        function (e)
        {
          if (!$(this).hasClass("wbs1-dropdown-selected"))
          {
            self.hideMenu($(this));
          }
        })
	    .bind("contextmenu.projectAction",
        function (e)
        {
          e.preventDefault();
          $(this).find("i").trigger("click.projectactions");
        });

    spans.find("i")
      .bind("click.projectactions", function (e)
      {
        ShowHideProjectActionByName('Copy', SelectBrowsers('ie')); //show the copy option only for IE.
        var $this = $(this).is("i") ? $(this).parents(".wbs1-dropdown:first") : $(this);
        $("iframe").each(function ()
        {
          try
          {
            $(this.contentWindow.document).unbind("click.projectactions");
          }
          catch (e) { }
        });
        $(document).unbind("click.projectactions");

        if ($this.hasClass("wbs1-dropdown-selected"))
        {
          $this.removeClass("wbs1-dropdown-selected");
          self.hideMenu($this);
          self.currentItem = null;
        }
        else
        {
          $this.addClass("wbs1-dropdown-selected");
          if (self.currentItem && self.currentItem.hasClass("wbs1-dropdown-selected"))
          {
            self.currentItem.removeClass("wbs1-dropdown-selected");
            self.hideMenu(self.currentItem);
          }
          self.currentItem = $this;
          var item = $(this);
          self.showMenu($this, true);
          setTimeout(function ()
          {
            $(document).bind("click.projectactions", function (e) { self.handleDocumentClick(e, item); });
            $("iframe").each(function ()
            {
              try
              {
                $(this.contentWindow.document).bind("click.projectactions", function (e) { self.handleDocumentClick(e, item); });
              }
              catch (e) { }
            });
          },
            100
          );
        }

        e.stopPropagation();
        e.preventDefault();
      });
  },

  handleDocumentClick: function (e, iconWrapper) {
    var link = $(e.target).parents("a[href]");
    if ($(e.target).parents(".hei-ctx-menu").length > 0
        && link.length > 0
        && link.attr("href") == "javascript:void(0);") {
      return;
    }
    else {
      iconWrapper.trigger("click.projectactions");
    }
  },

  closeUp: function (ele) {
    if (!ele) {
      return;
    }

    ele.removeClass("wbs1-selected");
    ele.removeClass("wbs1-hover");
    this.hideMenu(ele);
  },

  getContext: function (ele) {
    if (ele.is(".wbs1")) {
      return ele.get(0);
    }
    var wsb1Parents = ele.parents(".wbs1:first");
    if (wsb1Parents.length == 1) {
      return wsb1Parents.get(0);
    }

    // we moused over to the context menu
    if (ele.is(".hei-ctx-menu")) {
      return ele.get(0);
    }

    var ctxMenuParents = ele.parents(".hei-ctx-menu:first");
    if (ctxMenuParents.length == 1) {
      return ctxMenuParents.get(0);
    }

    return null;
  },

  buildLoadingMenu: function (item) {
    var wbs1ID = this.getWBS1ID(item.attr("wbs1"));
    if ($("#" + wbs1ID).length == 0) {
      var myMenu = $("<ul class='hei-ctx-menu'><li><a href='#'><div class='icon'></div><div class='name'>Loading...</div></a></li></ul>");
      myMenu.attr("id", wbs1ID);
      $("body").append(myMenu);

      var self = this;
      setTimeout(function () { self.loadMenu(item); }, 0);
    }
  },

  getMenu: function (item) {
    return $("#" + this.getWBS1ID($(item).attr("wbs1")));
  },

  showMenu: function (item, isActionBar) {
    if (!item) { 
      return;
    }

    var myMenu = this.getMenu(item);
    var of = item.offset();

    if (!isActionBar)
    {
      myMenu.css(
      {
        left: of.left,
        top: of.top + item.outerHeight() - 1
      });
    }
    else
    {
      myMenu.css(
        {
          left: of.left - myMenu.outerWidth() + item.outerWidth() - 1,
          top: of.top + item.outerHeight(true) - 2
        });
    }
    // setting overflow to visible (which is supposed to happen after the animation automatically)
    // is necessary in ie6 after the jquery1.5 (or ui 1.8.11) upgrade broke it
    myMenu.slideDown(150, function () { $(this).css("overflow", "visible"); });
  },

  hideMenu: function (item) {
    if (!item) {
      return;
    }

    var myMenu = this.getMenu(item);
    myMenu.slideUp(100);
  },

  loadMenu: function (item) {
    var self = this;
    HEIJS.page.Projects.data.getProjectActionsByWBS1(
      item.attr("wbs1"),
      function (data) { self.finishLoadMenu({ data: data, item: item }); }
    );
  },

  finishLoadMenu: function (result) {
    var data = result.data;
    var loadingItem = result.item;

    //continue
    var wbs1 = loadingItem.attr("wbs1");
    if (data.length > 0 && data[0].WBS1 == wbs1) {
      // continue and wrap up
      var lo = loadingItem;
      var myMenu = this.getMenu(lo);
      if (myMenu.length > 0) {
        myMenu.find("li").remove();
        myMenu.attr("pid", data.ProjectId);
        for (var x = 0; x < data.length; x++) {
          this.buildMenuItem(data[x], myMenu);
        }
        myMenu.find("li").hover(
				  function () {
				    $(this).toggleClass("hover");
				  },
				  function () {
				    $(this).toggleClass("hover");
				  }
			  );

        myMenu.find("li:has(ul)").hover(
				  function () {
				    var submenu = $(this).find("ul:first");
				    var of = $(this).position();

				    submenu.css({ left: $(this).width() - 2, top: of.top });
				    submenu.show(100);
				  },
				  function () {
				    $(this).find("ul").hide(100); //collapse all 
				  }
			  ).find("div.name:first").addClass("expand");
      }
    }
    else {
      this.getMenu(loadingItem).find("div.name").text("Error - does this project exist?");
	  this.closeUp(loadingItem);
	  this.removeActions(loadingItem);
    }
  },

  buildMenuItem: function (action, parentElement) {
    var li = $("<li></li>");

    if (action.Name == "-") {
      parentElement.find("li:last").addClass("separator");
      return;
    }
    else {
      var el = "";
      if (action.Action == null) {
        el = "<a href='javascript:void(0);'><div class='icon'></div><div class='name'>" + action.Name + "</div></a>";
      }
      else {
        el = "<a href='" + HEIJS.context.convertToContextUri(action.Action) + "' target='_parent'><div class='icon'></div><div class='name'>" + action.Name + "</div></a>";
      }

      li.html(el);
      if (action.NewWindow) {
        li.find("a:first").attr("target", "_blank");
      }

      if (action.Icon != null) {
        $("div.icon", li).append($("<i></i>").addClass(action.Icon));
      }

      if (action.Actions.length > 0) {
        var ul = $("<ul/>");
        li.append(ul);
        for (var x = 0; x < action.Actions.length; x++) {
          this.buildMenuItem(action.Actions[x], ul);
        }
        if (li.find("li:last").is(".separator")) { //remove last separator if this is the last element
          li.find("li.last").removeClass("separator");
        }
      }
    }
    parentElement.append(li);
  },

  buildDialog: function () {
    this.dialog = $("<div style='display: none' id='project-summary-div'></div>");
    $("body").append(this.dialog);
  },

  buildHEILandedDialog: function () {
    this.heiLandedDialog = $("<div style='display: none' id='project-heilanded-popup'></div>");
    $("body").append(this.heiLandedDialog);
  },

  loadProjectDetails: function (id) {
    var self = this;
    
    $().projectInfoTip('hide');
    
    if (HEIJS.page.systemStatus.statusPopup.length > 0) {
      HEIJS.page.systemStatus.show("Loading project details");
    }
    
    setTimeout(function() {
      if (self.dialog) {
        self.dialog.dialog({
          autoOpen: false,
          modal: true,
          width: 650,
          title: 'Project Details'
        });
      }
      
      HEIJS.page.Projects.data.getProjectById(id, function (data) { self.showProjectDetails(data); });
    }, 250);
  },

  loadHEILanded: function (id, projectNumber, status, closeAllActivePhases) {
    var self = this;
	if (this.heiLandedDialog) {
      HEIJS.page.systemStatus.show("Loading Proposal: HEI Landed");
      this.heiLandedDialog.dialog({
        autoOpen: false,
        modal: true,
        height: 125,
        width: 500,
        title: "Proposal",
        resizable: false,
        open: function (event, ui) {
          $(".ui-dialog-titlebar-close").hide();
        },
        buttons:
          {
            "Cancel": function () {
              self.heiLandedDialog.dialog("close");
            },
            "Project Died": function () {
              HEIJS.page.Projects.data.updateProposalStatus(id, projectNumber, status, "D", closeAllActivePhases, function (projectData) {
                StatusSuccessfullyUpdatedHandler(projectData, "D");
              });             
              self.heiLandedDialog.dialog("close");
            },
            "HEI Did Not Land": function () {
              HEIJS.page.Projects.data.updateProposalStatus(id, projectNumber, status, "N", closeAllActivePhases, function (projectData) {
                StatusSuccessfullyUpdatedHandler(projectData, "N");
              });           
              self.heiLandedDialog.dialog("close");
            },
            "HEI Landed": function () {
              HEIJS.page.Projects.data.updateProposalStatus(id, projectNumber, status, "L", closeAllActivePhases, function (projectData) {
                StatusSuccessfullyUpdatedHandler(projectData, "L");
              });           
              self.heiLandedDialog.dialog("close");
            }
          }
      });
    }

    this.showHEILandedDetails();
  },

  getLocationMap: function (data, content){
    var self = this;
    var locationContainer = content.find('div.locationContainer');

    self.setupMap('projectDetailsLocationMap');

    if (data.City === 'HEI') {
      data.City = 'Lenexa';
    }

    var geoCodingUrl = HEIJS.formatString('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/find?text={0}&f=pjson', encodeURIComponent((!!data.Address1 ? data.Address1 + ' ' : '') + data.City + ', ' + data.State + (!!data.PostalCode ? ' ' + data.PostalCode : '') + (!!data.Country ? ' ' + data.Country : '')))
      
    $.get(geoCodingUrl, function (result) {
      var locationData = JSON.parse(result);
        
      if (locationData.locations.length > 0) {
        var icon = L.divIcon({
          className: 'projectLocation',
          html: '<i class="fa fa-map-marker-alt projectLocationIcon"></i>'
        });
        
        var markerLatLng = L.latLng(locationData.locations[0].feature.geometry.y, locationData.locations[0].feature.geometry.x);
        locationContainer.data('markerLatLng', markerLatLng);

        var marker = L.marker(markerLatLng, { icon: icon }).addTo(self.map);
        $(marker._icon).attr('location', data.City + ', ' + data.State);
          
        self.map.setView(markerLatLng, 12);
      }
      else {
        $('<div>').addClass('noProjectLocationSet').html('No Project Location Set').appendTo(locationContainer);
      }
        
      locationContainer.heiOverlay('loadingOverlay').hide();
    });
  },

  showProjectDetails: function (data) {
    var self = this;
    
    if (self.dialog) {
      HEIJS.page.systemStatus.hide();
      var dialogContent = self.formatProjectData(data);
      self.dialog.empty().append(dialogContent).dialog("open");

      self.getLocationMap(data, dialogContent);
    }
  },

  showHEILandedDetails: function () {
    if (this.heiLandedDialog) {
      HEIJS.page.systemStatus.hide();
      this.heiLandedDialog.dialog("open");
      this.heiLandedDialog.html("<div>Did HEI Land the Proposal?</div>");
    }
  },
  
  setupMap: function(mapContainerId) {
    this.map = L.map(mapContainerId, {
      minZoom: 3,
      zoomControl: false
    }).setView([39.8282, -98.5795], 4);

    this.map.setMaxBounds([[22.494827, -134.378810], [51.414647, -60.682523]]); //don't allow panning away from the united states
    
    L.tileLayer('https://{s}.tiles.mapbox.com/v4/examples.ra3sdcxr/{z}/{x}/{y}.png?access_token=' + this.mapBoxAPIKey, {
      attribution: ''
    }).addTo(this.map);
  },

  formatProjectData: function (project) {
    var self = this;
    
    var projectActionsDetailsDialog = $('<div>').addClass('projectActionsDetailsDialog').on('mousewheel', 'div.projectDetailsTileContentScroller', function(e) {
      var scroller = this;

      if (scroller.scrollHeight > $(scroller).height() && ((scroller.scrollTop === 0 && e.deltaY > 0) || (scroller.scrollTop + $(scroller).height() === scroller.scrollHeight && e.deltaY < 0))) {
        return false;
      }
    });
    
    self.renderProjectSummary(project, true, true).appendTo(projectActionsDetailsDialog);
    
    self.renderStaff(project).appendTo(projectActionsDetailsDialog);
    
    var locationAndSchedulingRow = $('<div>').addClass('multiProjectDetailsTileRow').appendTo(projectActionsDetailsDialog);
    
    var locationContainer = $('<div>').addClass('projectDetailsTile').addClass('locationContainer').appendTo(locationAndSchedulingRow);
    locationContainer.heiOverlay({ overlay: { extension: { top: 40 } }, spinner: { height: '30px' } }).show();
    $('<div>').addClass('projectDetailsTileHeader').html('Location').appendTo(locationContainer);
    $('<div>').attr('id', 'projectDetailsLocationMap').appendTo(locationContainer);
    
    self.renderScheduling(project).appendTo(locationAndSchedulingRow);
    
    return projectActionsDetailsDialog;
  },
  
  renderProjectSummary: function (project, includeContractStatus, includeArchiveStatus) {
    var self = this;
    if (project.hasOwnProperty('projectDescription')) {
      project = HEIJS.convertProjectFromGraphqlToUpperCamel(project);
    }
    var isProposal = project.PhaseType == null ? false : project.PhaseType.split(':')[0] === 'Proposal';
    
    var projectSummarySection = $('<div>').addClass('projectActionsDetailsDialog-projectSummarySection');
    
    $('<div>').addClass('projectActionsDetailsDialog-projectStatusIndicator').attr('title', this.statusCodeToDescription[project.Status]).css('background-color', this.statusCodeToColor[project.Status]).appendTo(projectSummarySection);
    
    var projectOrProposalIndicator = $('<div>').addClass('projectActionsDetailsDialog-projectOrProposalIndicator').appendTo(projectSummarySection);
    $('<i>').addClass('fa').addClass(isProposal ? 'fa-file' : 'fa-cube').addClass('projectActionsDetailsDialog-projectOrProposalIndicatorIcon').appendTo(projectOrProposalIndicator);
    $('<div>').addClass('projectActionsDetailsDialog-projectOrProposalIndicatorText').html(isProposal ? 'Proposal' : 'Project').appendTo(projectOrProposalIndicator);
    
    
    
    var projectDetailsSection = $('<div>').addClass('projectActionsDetailsDialog-projectDetailsSection').appendTo(projectSummarySection);
    var projectAndStoreNumber = $('<div>').addClass('projectActionsDetailsDialog-projectAndStoreNumber').appendTo(projectDetailsSection);
    $('<a>').addClass('projectActionsDetailsDialog-projectNumber projectActionsDetailsDialog-proejctSummaryLink')
      .attr('title', 'Go to Project Summary')
      .html(project.WBS1)
      .attr('href', '/Projects/ProjectInfo/Summary/' + project.ProjectId)
      .appendTo(projectAndStoreNumber);
    $('<div>').addClass('projectActionsDetailsDialog-storeNumber').attr('title', 'Store Number').html(project.StoreNumber).appendTo(projectAndStoreNumber);
    $('<div>').addClass('projectActionsDetailsDialog-projectDescription').attr('title', 'Project Description').html(project.Description).appendTo(projectDetailsSection);
    $('<div>').addClass('projectActionsDetailsDialog-phaseDescription').attr('title', 'Phase Description').html(project.PhaseDescription).appendTo(projectDetailsSection);
    
    var projectSummarySectionFooter = $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooter').appendTo(projectDetailsSection);
    
    if (includeContractStatus) {
      var contractStatusContainer = $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('contractStatus').css('display','inline-block').appendTo(projectSummarySectionFooter).hide();
    }
    
    if (includeArchiveStatus) {
      var archiveStatusContainer = $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('archiveStatus').appendTo(projectSummarySectionFooter).hide();
    }
    
    var city = project.City;
    if (/hei/i.test(city)) { 
      city = 'Lenexa';
    }
    
    $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('location').attr('title', 'Location').html(city + ', ' + project.State).appendTo(projectSummarySectionFooter);
    $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('sector').attr('title', 'Sector').html(project.Sector).appendTo(projectSummarySectionFooter);
    $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('program').attr('title', 'Program').html(project.Program).appendTo(projectSummarySectionFooter);
    $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('department').attr('title', 'Department').html(project.Department).appendTo(projectSummarySectionFooter);
    
    var practiceHierarchy = [];
    
    if (project.Practice) {
      practiceHierarchy.push(project.Practice);
    }
    
    if (project.Subpractice) {
      practiceHierarchy.push(project.Subpractice);
    }
    
    /*
    // this makes it too long for the footer, so if we want this, we'll have to put it somewhere else
    if (project.ProjectType) {
      practiceHierarchy.push(project.ProjectType);
    }
    
    if (project.SubType) {
      practiceHierarchy.push(project.SubType);
    }
    */
    
    if (practiceHierarchy.length > 0) {
      $('<div>').addClass('projectActionsDetailsDialog-projectSummarySectionFooterItem').addClass('practiceHierarchy').attr('title', practiceHierarchy.length > 1 ? 'Practice / Subpractice' : 'Practice').html(practiceHierarchy.join(' / ')).appendTo(projectSummarySectionFooter);
    }    
    
    if (includeContractStatus) {
	  this.service.Get('Contract', { projectNumber: project.ProjectNumber })
	  .then(function(data){
		if (!data || !data.ContractStatus) throw 'no contract status found';
		$('<img>').addClass('projectActionsDetailsDialog-contractStatusIcon').attr('src', HEIJS.context.convertToContextUri(data.ContractStatus)).attr('title', data.ContractStatusMessage.replace(/<br\/>/g, '\r\n')).appendTo(projectSummarySection.find('div.projectActionsDetailsDialog-projectSummarySectionFooter:first').find('div.contractStatus:first').show());
	  })
	  .catch(function() {
		projectSummarySection.find('div.projectActionsDetailsDialog-projectSummarySectionFooter:first').find('div.contractStatus:first').remove();
	  });
    }
    
    if (includeArchiveStatus) {
	  this.service.Get('ArchiveStatus', { projectNumber: project.ProjectNumber })
	  .then(function(data){
		var archiveStatusImg = $('<img>').addClass('projectActionsDetailsDialog-archiveStatusImg');
        
        switch (data) {
          case 'no archives':
            projectSummarySection.find('div.projectActionsDetailsDialog-projectSummarySectionFooter:first').find('div.archiveStatus:first').remove();
            return;
            
          case 'physical only':
            archiveStatusImg.attr('src', '/HeiWebClient/Images/Icons/Box_small.gif').attr('title', 'Project has other archived materials but no electronic files stored.');
            break;
            
          case 'digital only':
            archiveStatusImg.attr('src', '/HeiWebClient/Images/Icons/CD.gif').attr('title', 'Project has electronic files stored but no other archived materials.');
            break;
            
          case 'physical and digital':
            archiveStatusImg.attr('src', '/HeiWebClient/Images/Icons/BoxCD.gif').attr('title', 'Project has electronic files stored and other archived materials.');
            break;
        }     
        
        archiveStatusImg.appendTo(projectSummarySection.find('div.projectActionsDetailsDialog-projectSummarySectionFooter:first').find('div.archiveStatus:first').show());
	  })
	  .catch(function(data){
		projectSummarySection.find('div.projectActionsDetailsDialog-projectSummarySectionFooter:first').find('div.archiveStatus:first').remove();
	  });
    }
    
    return projectSummarySection;
  },
  
  renderStaff: function(project) {
    var self = this;
    
    var staffContainer = $('<div>').addClass('projectDetailsTile').addClass('staffContainer');
    staffContainer.heiOverlay({ overlay: { extension: { top: 40 } }, spinner: { height: '30px' } }).show();
    
    $('<div>').addClass('projectDetailsTileHeader').html('Staff').appendTo(staffContainer);
    var allStaffScroller = $('<div>').addClass('allStaffScroller').addClass('projectDetailsTileContentScroller').appendTo(staffContainer);
    
	self.service.Get('ScheduledStaff', { projectId: project.ProjectId })
	.then(function(data){
	  for(var i = 0; i < data.length; i++) {
        if (data[i].DisciplineCode === 'A') {
          continue; //skip the Administration roles, we'll get those from the project object
        }
        
        if (!self.disciplineCodeToDescription.hasOwnProperty(data[i].DisciplineCode)) {
          data[i].DisciplineCode = 'MISC';
        }
        
        var staffDisciplineSection = allStaffScroller.find('div.staffDisciplineSection_' + data[i].DisciplineCode);
        
        if (staffDisciplineSection.length === 0) {
          staffDisciplineSection = $('<div>').addClass('staffDisciplineSection staffDisciplineSection_' + data[i].DisciplineCode).appendTo(allStaffScroller);
          var staffDisciplineIndicatorContainer = $('<div>').addClass('staffDisciplineIndicatorContainer').appendTo(staffDisciplineSection);
          $('<div>').addClass('staffDisciplineIndicator').html(self.disciplineCodeToDescription[data[i].DisciplineCode]).appendTo(staffDisciplineIndicatorContainer);
          $('<div>').addClass('staffDisciplineItems').appendTo(staffDisciplineSection);
        }
        
        $('<div>').addClass('staff').css('background-color', self.disciplineCodeToColor[data[i].DisciplineCode]).html(data[i].RoleName + '<span class="scheduledStaffPersonName">' + data[i].PersonName + '</span>').appendTo(staffDisciplineSection.find('div.staffDisciplineItems')).employeeInfoTip({ 
          PersonID: data[i].PersonId,
          additionalTitleText: '(' + data[i].RoleName + ')'
        });
	  }
       
      var staffDisciplineSection = $('<div>').addClass('staffDisciplineSection staffDisciplineSection_A').appendTo(allStaffScroller);
      var staffDisciplineIndicatorContainer = $('<div>').addClass('staffDisciplineIndicatorContainer').appendTo(staffDisciplineSection);
      $('<div>').addClass('staffDisciplineIndicator').html(self.disciplineCodeToDescription['A']).appendTo(staffDisciplineIndicatorContainer);
      $('<div>').addClass('staffDisciplineItems').appendTo(staffDisciplineSection);
      
      for (var i = 0; i < self.staffPrefix.length; i++) {
        var role = self.staffPrefix[i];
        var personId = project[role + 'ID'];
        
        if (personId > 0) {
          var personName = project[role + 'Name'];
		  var roleName = self.roleLookup[role] == 'Principal' ? 'Practice Director' : self.roleLookup[role];
          
          $('<div>').addClass('staff').css('background-color', self.disciplineCodeToColor['A']).html(roleName + '<span class="scheduledStaffPersonName">' + personName + '</span>').appendTo(staffDisciplineSection.find('div.staffDisciplineItems')).employeeInfoTip({ 
            PersonID: personId, 
            additionalTitleText: '(' + roleName + ')'
          });
        }
	  }
	})
	.finally(function(){
	  staffContainer.heiOverlay('loadingOverlay').hide();      
      self.dialog.dialog('option', 'position', { my: 'center', at: 'center', of: window });
	});
    
    return staffContainer;
  },

  renderScheduling: function(project) {
    var self = this;
    
    var schedulingContainer = $('<div>').addClass('projectDetailsTile').addClass('schedulingContainer');
    schedulingContainer.heiOverlay({ overlay: { extension: { top: 40 } }, spinner: { height: '30px' } }).show();
    
    $('<div>').addClass('projectDetailsTileHeader').html('Scheduling').appendTo(schedulingContainer);
    var projectDetailsSchedulingDates = $('<div>').addClass('projectDetailsSchedulingDates').addClass('projectDetailsTileContentScroller').appendTo(schedulingContainer);
    
	self.service.Get('ProjectDates', { projectId: project.ProjectId })
	.then(function(data){
	  if (data.length === 0) {
        $('<div>').addClass('projectDetailsSchedulingNoDates').html('No Dates Set').appendTo(projectDetailsSchedulingDates);
      }
      else {
        for (var i = 0; i < data.length; i++) {
          data[i].Date = HEIJS.toDateFromJson(data[i].Date);
        }
        
        data.sort(function(a, b) {
          if (a.Date < b.Date) {
            return -1;
          }
          
          if (a.Date > b.Date) {
            return 1;
          }
          
          return 0;
        });
        
        for (var i = 0; i < data.length; i++) {
          var projectDetailsSchedulingDate = $('<div>').addClass('projectDetailsSchedulingDate').appendTo(projectDetailsSchedulingDates)
          $('<div>').addClass('dateName').html(data[i].DateName).appendTo(projectDetailsSchedulingDate);
          $('<div>').addClass('date').html(moment(data[i].Date).format('MM/DD/YYYY')).appendTo(projectDetailsSchedulingDate);
        }
      }
	})
	.finally(function(){
	  schedulingContainer.heiOverlay('loadingOverlay').hide();
	});
      
    return schedulingContainer;
  },
  
  join: function (fieldList, data, sep) {
    var retVal = "";
    for (var x = 0; x < fieldList.length; x++) {
      if (data[fieldList[x]]) {
        if (retVal.length > 0) {
          retVal += sep || ",";
        }
        retVal += data[fieldList[x]];
      }
    }

    return retVal;
  }
};

$(document).ready(
	function ()
	{
	  HEIJS.page.Projects = new HEIJS.Projects();
	  HEIJS.page.ProjectActions = new HEIJS.Controls.ProjectActions();
	}
);

function ProjectDetails(id)
{
  if (HEIJS.page.ProjectActionsManager)
  {
    HEIJS.page.ProjectActionsManager.loadProjectDetails(id);
  }
}

function AddFavoriteProject(id)
{
  if (HEIJS.page.Projects)
  {
    HEIJS.page.Projects.favorites.addFavoriteProject(id,
			function (success)
			{
			  // timeout gives menu time to close
			  setTimeout(function ()
			  {
				new HEIJS.Controls.NotyMessage('Successfully added the project to your favorite projects list', 'ui-icon-info', true, { layout: 'topRight', type: 'success', timeout: 5000 }).showMessages();
			  },
			  100);
			}
		);
  }
}

function RemoveFavoriteProject(id)
{
  if (HEIJS.page.Projects)
  {
    HEIJS.page.Projects.favorites.removeFavoriteProject(id,
			function (projectData)
			{
			  // timeout gives menu time to close
			  setTimeout(function ()
			  {
				new HEIJS.Controls.NotyMessage('Successfully removed ' + projectData.WBS1 + ' from your favorite projects list', 'ui-icon-info', true, { layout: 'topRight', type: 'success', timeout: 5000 }).showMessages();
			  },
			  100);
			}
		);
  }
}

function GetAssignedEmployeesForProject(id, wbs1) {
  if (HEIJS.page.Projects) {
    HEIJS.page.Projects.favorites.getAssignedEmployeesForProject(id,
			function (employeeData) {
        if (employeeData) {
          if (employeeData && employeeData.length > 0) {
            window.location.href = 'mailto:' + employeeData.join(';') + '?body=' + wbs1;
          } else {
            new HEIJS.Controls.NotyMessage('No staff members have been assigned to the current schedule', 'ui-icon-info', true, { layout: 'topRight', type: 'warning', timeout: 5000 }).showMessages();
          }
        }
			}
		);
  }
}

function StatusSuccessfullyUpdatedHandler(projectData, heiLanded, closeAllActivePhases)
{
  var fullStatus;

  if (projectData.Status == "H")
    fullStatus = "On Hold";
  else if (projectData.Status == "C")
    fullStatus = "Completed";
  else if (projectData.Status == "T")
    fullStatus = "Terminated/Cancelled";
  else
    fullStatus = "Active";
  var text;
  if (closeAllActivePhases) {
    text = 'Successfully updated projects related to "' + projectData.ProjectNumber + '" to status "' + fullStatus + "'.";
  } else {
    text = 'Successfully updated project "' + projectData.WBS1 + '" to status "' + fullStatus + "'.";
  }

  if ((projectData.Status == "C" || projectData.Status == "T") && heiLanded != null && heiLanded != "")
  {
	text += '"  The proposal ';
	if(heiLanded == "L") {
		text += "was landed by HEI.";
	}
	else if (heiLanded == "N") {
		text += "was not landed by HEI.";
	}
	else if(heiLanded == "D") {
		text += "died.";
	}
  }
  new HEIJS.Controls.NotyMessage(text, 'ui-icon-info', true, { layout: 'topRight', type: 'success', timeout: 5000 }).showMessages();
}

function UpdateProposalStatus(id, projectNumber, status, closeAllActivePhases)
{
  if (HEIJS.page.ProjectActionsManager) {
    HEIJS.page.ProjectActionsManager.loadHEILanded(id, projectNumber, status, closeAllActivePhases);
  }
}

function UpdateProjectStatus(id, projectNumber, status, closeAllActivePhases)
{
  if (HEIJS.page.Projects) {
    HEIJS.page.Projects.data.updateProjectStatus(id, projectNumber, status, closeAllActivePhases, function (projectData) { StatusSuccessfullyUpdatedHandler(projectData, null, closeAllActivePhases); });    
  }
}

function copyProjectNumberAndPhase()
{
  var shownProjectTooltip = $('div.hei-projecttip-container.shown');
  window.clipboardData.setData("Text", shownProjectTooltip.length > 0 ? shownProjectTooltip.find('a.hei-projecttip-details-header-text').text() : $('ul.hei-ctx-menu li.hover').parent().attr('id').replace(/_/g, '.'));
}

function ShowHideProjectActionByName(projectActionName, show)
{
  if (show)
  {
    $("ul.hei-ctx-menu li:contains('" + projectActionName + "')").show();
  }
  else
  {
    $("ul.hei-ctx-menu li:contains('" + projectActionName + "')").hide();
  }
}

//possible options for code: 'ie', 'firefox', 'chrome', 'safari', 'opera', 'all', or any combination of specific browsers separated by commas.
function SelectBrowsers(code)
{
  if (code.toLowerCase().match('all'))
  {
    return true;
  }

  var result = false;
  $.each(code.toLowerCase().split(','), function (index, value)
  {
    switch (value)
    {
      case 'ie':
        result = result || $.browser.msie;
        break;

      case 'firefox':
        result = result || $.browser.mozilla;
        break;

      case 'opera':
        result = result || $.browser.opera;
        break;

      case 'chrome':
        result = result || $.browser.webkit || $.browser.chrome;
        break;

      case 'safari':
        result = result || $.browser.webkit;
        break;
    }
  });

  if (result == undefined)
  {
    result = false;
  }

  return result;
}